import React from 'react';

function CommentCheckIcon({ size }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 48 48"
    >
      <g clipPath="url(#clip0_4188_29356)">
        <path
          fill="#049B56"
          d="M24 0a24 24 0 100 48h24V24A24.026 24.026 0 0024 0zm-.182 32.838a4 4 0 01-5.646 0L10.6 25.43l2.8-2.86 7.586 7.414 13.612-13.4 2.8 2.848-13.58 13.406z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_4188_29356">
          <path fill="#fff" d="M0 0H48V48H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default CommentCheckIcon;
